
import React from 'react';
import { Alert, Button, Text, Title } from '@mantine/core';
import { AlertTriangle, LogOut } from 'lucide-react';

interface NoCustomersStateProps {
  onLogout: () => void;
}

const NoCustomersState: React.FC<NoCustomersStateProps> = ({ onLogout }) => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 448, display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <AlertTriangle size={48} style={{ color: 'var(--mantine-color-red-6)' }} />
        </div>

        <Title order={2} ta="center">Access Denied</Title>

        <Alert color="red">
          <Title order={5} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <AlertTriangle size={16} />
            No Customer Access
          </Title>
          <Text size="sm" mt="xs">
            You do not have access to any customers. Please contact your administrator or support team for assistance.
          </Text>
        </Alert>

        <Text size="sm" c="dimmed" ta="center" mt="md">
          If you believe this is an error, please check your account permissions or contact support.
        </Text>

        <Button
          variant="outline"
          fullWidth
          mt="md"
          onClick={onLogout}
          leftSection={<LogOut size={16} />}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default NoCustomersState;
